/* eslint-disable */
import { grpc } from "@injectivelabs/grpc-web";
import { BrowserHeaders } from "browser-headers";
import Long from "long";
import _m0 from "protobufjs/minimal.js";
import { PageRequest, PageResponse } from "../../../cosmos/base/query/v1beta1/pagination.js";
import { Timestamp } from "../../../google/protobuf/timestamp.js";
import { Log } from "./log.js";
import { Params } from "./params.js";
import { TraceConfig } from "./trace_config.js";
import { MsgEthereumTx, MsgEthereumTxResponse } from "./tx.js";
export const protobufPackage = "injective.evm.v1";
function createBaseQueryAccountRequest() {
    return { address: "" };
}
export const QueryAccountRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAccountRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { address: isSet(object.address) ? String(object.address) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    create(base) {
        return QueryAccountRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseQueryAccountRequest();
        message.address = object.address ?? "";
        return message;
    },
};
function createBaseQueryAccountResponse() {
    return { balance: "", codeHash: "", nonce: "0" };
}
export const QueryAccountResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.balance !== "") {
            writer.uint32(10).string(message.balance);
        }
        if (message.codeHash !== "") {
            writer.uint32(18).string(message.codeHash);
        }
        if (message.nonce !== "0") {
            writer.uint32(24).uint64(message.nonce);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAccountResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.balance = reader.string();
                    break;
                case 2:
                    message.codeHash = reader.string();
                    break;
                case 3:
                    message.nonce = longToString(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            balance: isSet(object.balance) ? String(object.balance) : "",
            codeHash: isSet(object.codeHash) ? String(object.codeHash) : "",
            nonce: isSet(object.nonce) ? String(object.nonce) : "0",
        };
    },
    toJSON(message) {
        const obj = {};
        message.balance !== undefined && (obj.balance = message.balance);
        message.codeHash !== undefined && (obj.codeHash = message.codeHash);
        message.nonce !== undefined && (obj.nonce = message.nonce);
        return obj;
    },
    create(base) {
        return QueryAccountResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseQueryAccountResponse();
        message.balance = object.balance ?? "";
        message.codeHash = object.codeHash ?? "";
        message.nonce = object.nonce ?? "0";
        return message;
    },
};
function createBaseQueryCosmosAccountRequest() {
    return { address: "" };
}
export const QueryCosmosAccountRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryCosmosAccountRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { address: isSet(object.address) ? String(object.address) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    create(base) {
        return QueryCosmosAccountRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseQueryCosmosAccountRequest();
        message.address = object.address ?? "";
        return message;
    },
};
function createBaseQueryCosmosAccountResponse() {
    return { cosmosAddress: "", sequence: "0", accountNumber: "0" };
}
export const QueryCosmosAccountResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.cosmosAddress !== "") {
            writer.uint32(10).string(message.cosmosAddress);
        }
        if (message.sequence !== "0") {
            writer.uint32(16).uint64(message.sequence);
        }
        if (message.accountNumber !== "0") {
            writer.uint32(24).uint64(message.accountNumber);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryCosmosAccountResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.cosmosAddress = reader.string();
                    break;
                case 2:
                    message.sequence = longToString(reader.uint64());
                    break;
                case 3:
                    message.accountNumber = longToString(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            cosmosAddress: isSet(object.cosmosAddress) ? String(object.cosmosAddress) : "",
            sequence: isSet(object.sequence) ? String(object.sequence) : "0",
            accountNumber: isSet(object.accountNumber) ? String(object.accountNumber) : "0",
        };
    },
    toJSON(message) {
        const obj = {};
        message.cosmosAddress !== undefined && (obj.cosmosAddress = message.cosmosAddress);
        message.sequence !== undefined && (obj.sequence = message.sequence);
        message.accountNumber !== undefined && (obj.accountNumber = message.accountNumber);
        return obj;
    },
    create(base) {
        return QueryCosmosAccountResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseQueryCosmosAccountResponse();
        message.cosmosAddress = object.cosmosAddress ?? "";
        message.sequence = object.sequence ?? "0";
        message.accountNumber = object.accountNumber ?? "0";
        return message;
    },
};
function createBaseQueryValidatorAccountRequest() {
    return { consAddress: "" };
}
export const QueryValidatorAccountRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.consAddress !== "") {
            writer.uint32(10).string(message.consAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryValidatorAccountRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.consAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { consAddress: isSet(object.consAddress) ? String(object.consAddress) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.consAddress !== undefined && (obj.consAddress = message.consAddress);
        return obj;
    },
    create(base) {
        return QueryValidatorAccountRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseQueryValidatorAccountRequest();
        message.consAddress = object.consAddress ?? "";
        return message;
    },
};
function createBaseQueryValidatorAccountResponse() {
    return { accountAddress: "", sequence: "0", accountNumber: "0" };
}
export const QueryValidatorAccountResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.accountAddress !== "") {
            writer.uint32(10).string(message.accountAddress);
        }
        if (message.sequence !== "0") {
            writer.uint32(16).uint64(message.sequence);
        }
        if (message.accountNumber !== "0") {
            writer.uint32(24).uint64(message.accountNumber);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryValidatorAccountResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.accountAddress = reader.string();
                    break;
                case 2:
                    message.sequence = longToString(reader.uint64());
                    break;
                case 3:
                    message.accountNumber = longToString(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            accountAddress: isSet(object.accountAddress) ? String(object.accountAddress) : "",
            sequence: isSet(object.sequence) ? String(object.sequence) : "0",
            accountNumber: isSet(object.accountNumber) ? String(object.accountNumber) : "0",
        };
    },
    toJSON(message) {
        const obj = {};
        message.accountAddress !== undefined && (obj.accountAddress = message.accountAddress);
        message.sequence !== undefined && (obj.sequence = message.sequence);
        message.accountNumber !== undefined && (obj.accountNumber = message.accountNumber);
        return obj;
    },
    create(base) {
        return QueryValidatorAccountResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseQueryValidatorAccountResponse();
        message.accountAddress = object.accountAddress ?? "";
        message.sequence = object.sequence ?? "0";
        message.accountNumber = object.accountNumber ?? "0";
        return message;
    },
};
function createBaseQueryBalanceRequest() {
    return { address: "" };
}
export const QueryBalanceRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryBalanceRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { address: isSet(object.address) ? String(object.address) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    create(base) {
        return QueryBalanceRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseQueryBalanceRequest();
        message.address = object.address ?? "";
        return message;
    },
};
function createBaseQueryBalanceResponse() {
    return { balance: "" };
}
export const QueryBalanceResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.balance !== "") {
            writer.uint32(10).string(message.balance);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryBalanceResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.balance = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { balance: isSet(object.balance) ? String(object.balance) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.balance !== undefined && (obj.balance = message.balance);
        return obj;
    },
    create(base) {
        return QueryBalanceResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseQueryBalanceResponse();
        message.balance = object.balance ?? "";
        return message;
    },
};
function createBaseQueryStorageRequest() {
    return { address: "", key: "" };
}
export const QueryStorageRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (message.key !== "") {
            writer.uint32(18).string(message.key);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryStorageRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.key = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: isSet(object.address) ? String(object.address) : "",
            key: isSet(object.key) ? String(object.key) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.key !== undefined && (obj.key = message.key);
        return obj;
    },
    create(base) {
        return QueryStorageRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseQueryStorageRequest();
        message.address = object.address ?? "";
        message.key = object.key ?? "";
        return message;
    },
};
function createBaseQueryStorageResponse() {
    return { value: "" };
}
export const QueryStorageResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.value !== "") {
            writer.uint32(10).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryStorageResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.value = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { value: isSet(object.value) ? String(object.value) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.value !== undefined && (obj.value = message.value);
        return obj;
    },
    create(base) {
        return QueryStorageResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseQueryStorageResponse();
        message.value = object.value ?? "";
        return message;
    },
};
function createBaseQueryCodeRequest() {
    return { address: "" };
}
export const QueryCodeRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryCodeRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { address: isSet(object.address) ? String(object.address) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    create(base) {
        return QueryCodeRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseQueryCodeRequest();
        message.address = object.address ?? "";
        return message;
    },
};
function createBaseQueryCodeResponse() {
    return { code: new Uint8Array() };
}
export const QueryCodeResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.code.length !== 0) {
            writer.uint32(10).bytes(message.code);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryCodeResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.code = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { code: isSet(object.code) ? bytesFromBase64(object.code) : new Uint8Array() };
    },
    toJSON(message) {
        const obj = {};
        message.code !== undefined &&
            (obj.code = base64FromBytes(message.code !== undefined ? message.code : new Uint8Array()));
        return obj;
    },
    create(base) {
        return QueryCodeResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseQueryCodeResponse();
        message.code = object.code ?? new Uint8Array();
        return message;
    },
};
function createBaseQueryTxLogsRequest() {
    return { hash: "", pagination: undefined };
}
export const QueryTxLogsRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.hash !== "") {
            writer.uint32(10).string(message.hash);
        }
        if (message.pagination !== undefined) {
            PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryTxLogsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.hash = reader.string();
                    break;
                case 2:
                    message.pagination = PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            hash: isSet(object.hash) ? String(object.hash) : "",
            pagination: isSet(object.pagination) ? PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = message.hash);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    create(base) {
        return QueryTxLogsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseQueryTxLogsRequest();
        message.hash = object.hash ?? "";
        message.pagination = (object.pagination !== undefined && object.pagination !== null)
            ? PageRequest.fromPartial(object.pagination)
            : undefined;
        return message;
    },
};
function createBaseQueryTxLogsResponse() {
    return { logs: [], pagination: undefined };
}
export const QueryTxLogsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.logs) {
            Log.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryTxLogsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.logs.push(Log.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            logs: Array.isArray(object?.logs) ? object.logs.map((e) => Log.fromJSON(e)) : [],
            pagination: isSet(object.pagination) ? PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.logs) {
            obj.logs = message.logs.map((e) => e ? Log.toJSON(e) : undefined);
        }
        else {
            obj.logs = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    create(base) {
        return QueryTxLogsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseQueryTxLogsResponse();
        message.logs = object.logs?.map((e) => Log.fromPartial(e)) || [];
        message.pagination = (object.pagination !== undefined && object.pagination !== null)
            ? PageResponse.fromPartial(object.pagination)
            : undefined;
        return message;
    },
};
function createBaseQueryParamsRequest() {
    return {};
}
export const QueryParamsRequest = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return QueryParamsRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseQueryParamsRequest();
        return message;
    },
};
function createBaseQueryParamsResponse() {
    return { params: undefined };
}
export const QueryParamsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.params !== undefined) {
            Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { params: isSet(object.params) ? Params.fromJSON(object.params) : undefined };
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? Params.toJSON(message.params) : undefined);
        return obj;
    },
    create(base) {
        return QueryParamsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseQueryParamsResponse();
        message.params = (object.params !== undefined && object.params !== null)
            ? Params.fromPartial(object.params)
            : undefined;
        return message;
    },
};
function createBaseEthCallRequest() {
    return {
        args: new Uint8Array(),
        gasCap: "0",
        proposerAddress: new Uint8Array(),
        chainId: "0",
        overrides: new Uint8Array(),
    };
}
export const EthCallRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.args.length !== 0) {
            writer.uint32(10).bytes(message.args);
        }
        if (message.gasCap !== "0") {
            writer.uint32(16).uint64(message.gasCap);
        }
        if (message.proposerAddress.length !== 0) {
            writer.uint32(26).bytes(message.proposerAddress);
        }
        if (message.chainId !== "0") {
            writer.uint32(32).int64(message.chainId);
        }
        if (message.overrides.length !== 0) {
            writer.uint32(42).bytes(message.overrides);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEthCallRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.args = reader.bytes();
                    break;
                case 2:
                    message.gasCap = longToString(reader.uint64());
                    break;
                case 3:
                    message.proposerAddress = reader.bytes();
                    break;
                case 4:
                    message.chainId = longToString(reader.int64());
                    break;
                case 5:
                    message.overrides = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            args: isSet(object.args) ? bytesFromBase64(object.args) : new Uint8Array(),
            gasCap: isSet(object.gasCap) ? String(object.gasCap) : "0",
            proposerAddress: isSet(object.proposerAddress) ? bytesFromBase64(object.proposerAddress) : new Uint8Array(),
            chainId: isSet(object.chainId) ? String(object.chainId) : "0",
            overrides: isSet(object.overrides) ? bytesFromBase64(object.overrides) : new Uint8Array(),
        };
    },
    toJSON(message) {
        const obj = {};
        message.args !== undefined &&
            (obj.args = base64FromBytes(message.args !== undefined ? message.args : new Uint8Array()));
        message.gasCap !== undefined && (obj.gasCap = message.gasCap);
        message.proposerAddress !== undefined &&
            (obj.proposerAddress = base64FromBytes(message.proposerAddress !== undefined ? message.proposerAddress : new Uint8Array()));
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.overrides !== undefined &&
            (obj.overrides = base64FromBytes(message.overrides !== undefined ? message.overrides : new Uint8Array()));
        return obj;
    },
    create(base) {
        return EthCallRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEthCallRequest();
        message.args = object.args ?? new Uint8Array();
        message.gasCap = object.gasCap ?? "0";
        message.proposerAddress = object.proposerAddress ?? new Uint8Array();
        message.chainId = object.chainId ?? "0";
        message.overrides = object.overrides ?? new Uint8Array();
        return message;
    },
};
function createBaseEstimateGasResponse() {
    return { gas: "0", ret: new Uint8Array(), vmError: "" };
}
export const EstimateGasResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.gas !== "0") {
            writer.uint32(8).uint64(message.gas);
        }
        if (message.ret.length !== 0) {
            writer.uint32(18).bytes(message.ret);
        }
        if (message.vmError !== "") {
            writer.uint32(26).string(message.vmError);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEstimateGasResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.gas = longToString(reader.uint64());
                    break;
                case 2:
                    message.ret = reader.bytes();
                    break;
                case 3:
                    message.vmError = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            gas: isSet(object.gas) ? String(object.gas) : "0",
            ret: isSet(object.ret) ? bytesFromBase64(object.ret) : new Uint8Array(),
            vmError: isSet(object.vmError) ? String(object.vmError) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.gas !== undefined && (obj.gas = message.gas);
        message.ret !== undefined &&
            (obj.ret = base64FromBytes(message.ret !== undefined ? message.ret : new Uint8Array()));
        message.vmError !== undefined && (obj.vmError = message.vmError);
        return obj;
    },
    create(base) {
        return EstimateGasResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEstimateGasResponse();
        message.gas = object.gas ?? "0";
        message.ret = object.ret ?? new Uint8Array();
        message.vmError = object.vmError ?? "";
        return message;
    },
};
function createBaseQueryTraceTxRequest() {
    return {
        msg: undefined,
        traceConfig: undefined,
        predecessors: [],
        blockNumber: "0",
        blockHash: "",
        blockTime: undefined,
        proposerAddress: new Uint8Array(),
        chainId: "0",
    };
}
export const QueryTraceTxRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.msg !== undefined) {
            MsgEthereumTx.encode(message.msg, writer.uint32(10).fork()).ldelim();
        }
        if (message.traceConfig !== undefined) {
            TraceConfig.encode(message.traceConfig, writer.uint32(26).fork()).ldelim();
        }
        for (const v of message.predecessors) {
            MsgEthereumTx.encode(v, writer.uint32(34).fork()).ldelim();
        }
        if (message.blockNumber !== "0") {
            writer.uint32(40).int64(message.blockNumber);
        }
        if (message.blockHash !== "") {
            writer.uint32(50).string(message.blockHash);
        }
        if (message.blockTime !== undefined) {
            Timestamp.encode(toTimestamp(message.blockTime), writer.uint32(58).fork()).ldelim();
        }
        if (message.proposerAddress.length !== 0) {
            writer.uint32(66).bytes(message.proposerAddress);
        }
        if (message.chainId !== "0") {
            writer.uint32(72).int64(message.chainId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryTraceTxRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.msg = MsgEthereumTx.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.traceConfig = TraceConfig.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.predecessors.push(MsgEthereumTx.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.blockNumber = longToString(reader.int64());
                    break;
                case 6:
                    message.blockHash = reader.string();
                    break;
                case 7:
                    message.blockTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.proposerAddress = reader.bytes();
                    break;
                case 9:
                    message.chainId = longToString(reader.int64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            msg: isSet(object.msg) ? MsgEthereumTx.fromJSON(object.msg) : undefined,
            traceConfig: isSet(object.traceConfig) ? TraceConfig.fromJSON(object.traceConfig) : undefined,
            predecessors: Array.isArray(object?.predecessors)
                ? object.predecessors.map((e) => MsgEthereumTx.fromJSON(e))
                : [],
            blockNumber: isSet(object.blockNumber) ? String(object.blockNumber) : "0",
            blockHash: isSet(object.blockHash) ? String(object.blockHash) : "",
            blockTime: isSet(object.blockTime) ? fromJsonTimestamp(object.blockTime) : undefined,
            proposerAddress: isSet(object.proposerAddress) ? bytesFromBase64(object.proposerAddress) : new Uint8Array(),
            chainId: isSet(object.chainId) ? String(object.chainId) : "0",
        };
    },
    toJSON(message) {
        const obj = {};
        message.msg !== undefined && (obj.msg = message.msg ? MsgEthereumTx.toJSON(message.msg) : undefined);
        message.traceConfig !== undefined &&
            (obj.traceConfig = message.traceConfig ? TraceConfig.toJSON(message.traceConfig) : undefined);
        if (message.predecessors) {
            obj.predecessors = message.predecessors.map((e) => e ? MsgEthereumTx.toJSON(e) : undefined);
        }
        else {
            obj.predecessors = [];
        }
        message.blockNumber !== undefined && (obj.blockNumber = message.blockNumber);
        message.blockHash !== undefined && (obj.blockHash = message.blockHash);
        message.blockTime !== undefined && (obj.blockTime = message.blockTime.toISOString());
        message.proposerAddress !== undefined &&
            (obj.proposerAddress = base64FromBytes(message.proposerAddress !== undefined ? message.proposerAddress : new Uint8Array()));
        message.chainId !== undefined && (obj.chainId = message.chainId);
        return obj;
    },
    create(base) {
        return QueryTraceTxRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseQueryTraceTxRequest();
        message.msg = (object.msg !== undefined && object.msg !== null) ? MsgEthereumTx.fromPartial(object.msg) : undefined;
        message.traceConfig = (object.traceConfig !== undefined && object.traceConfig !== null)
            ? TraceConfig.fromPartial(object.traceConfig)
            : undefined;
        message.predecessors = object.predecessors?.map((e) => MsgEthereumTx.fromPartial(e)) || [];
        message.blockNumber = object.blockNumber ?? "0";
        message.blockHash = object.blockHash ?? "";
        message.blockTime = object.blockTime ?? undefined;
        message.proposerAddress = object.proposerAddress ?? new Uint8Array();
        message.chainId = object.chainId ?? "0";
        return message;
    },
};
function createBaseQueryTraceTxResponse() {
    return { data: new Uint8Array() };
}
export const QueryTraceTxResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.data.length !== 0) {
            writer.uint32(10).bytes(message.data);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryTraceTxResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { data: isSet(object.data) ? bytesFromBase64(object.data) : new Uint8Array() };
    },
    toJSON(message) {
        const obj = {};
        message.data !== undefined &&
            (obj.data = base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    create(base) {
        return QueryTraceTxResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseQueryTraceTxResponse();
        message.data = object.data ?? new Uint8Array();
        return message;
    },
};
function createBaseQueryTraceCallRequest() {
    return {
        args: new Uint8Array(),
        gasCap: "0",
        proposerAddress: new Uint8Array(),
        traceConfig: undefined,
        blockNumber: "0",
        blockHash: "",
        blockTime: undefined,
        chainId: "0",
    };
}
export const QueryTraceCallRequest = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.args.length !== 0) {
            writer.uint32(10).bytes(message.args);
        }
        if (message.gasCap !== "0") {
            writer.uint32(16).uint64(message.gasCap);
        }
        if (message.proposerAddress.length !== 0) {
            writer.uint32(26).bytes(message.proposerAddress);
        }
        if (message.traceConfig !== undefined) {
            TraceConfig.encode(message.traceConfig, writer.uint32(34).fork()).ldelim();
        }
        if (message.blockNumber !== "0") {
            writer.uint32(40).int64(message.blockNumber);
        }
        if (message.blockHash !== "") {
            writer.uint32(50).string(message.blockHash);
        }
        if (message.blockTime !== undefined) {
            Timestamp.encode(toTimestamp(message.blockTime), writer.uint32(58).fork()).ldelim();
        }
        if (message.chainId !== "0") {
            writer.uint32(64).int64(message.chainId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryTraceCallRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.args = reader.bytes();
                    break;
                case 2:
                    message.gasCap = longToString(reader.uint64());
                    break;
                case 3:
                    message.proposerAddress = reader.bytes();
                    break;
                case 4:
                    message.traceConfig = TraceConfig.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.blockNumber = longToString(reader.int64());
                    break;
                case 6:
                    message.blockHash = reader.string();
                    break;
                case 7:
                    message.blockTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.chainId = longToString(reader.int64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            args: isSet(object.args) ? bytesFromBase64(object.args) : new Uint8Array(),
            gasCap: isSet(object.gasCap) ? String(object.gasCap) : "0",
            proposerAddress: isSet(object.proposerAddress) ? bytesFromBase64(object.proposerAddress) : new Uint8Array(),
            traceConfig: isSet(object.traceConfig) ? TraceConfig.fromJSON(object.traceConfig) : undefined,
            blockNumber: isSet(object.blockNumber) ? String(object.blockNumber) : "0",
            blockHash: isSet(object.blockHash) ? String(object.blockHash) : "",
            blockTime: isSet(object.blockTime) ? fromJsonTimestamp(object.blockTime) : undefined,
            chainId: isSet(object.chainId) ? String(object.chainId) : "0",
        };
    },
    toJSON(message) {
        const obj = {};
        message.args !== undefined &&
            (obj.args = base64FromBytes(message.args !== undefined ? message.args : new Uint8Array()));
        message.gasCap !== undefined && (obj.gasCap = message.gasCap);
        message.proposerAddress !== undefined &&
            (obj.proposerAddress = base64FromBytes(message.proposerAddress !== undefined ? message.proposerAddress : new Uint8Array()));
        message.traceConfig !== undefined &&
            (obj.traceConfig = message.traceConfig ? TraceConfig.toJSON(message.traceConfig) : undefined);
        message.blockNumber !== undefined && (obj.blockNumber = message.blockNumber);
        message.blockHash !== undefined && (obj.blockHash = message.blockHash);
        message.blockTime !== undefined && (obj.blockTime = message.blockTime.toISOString());
        message.chainId !== undefined && (obj.chainId = message.chainId);
        return obj;
    },
    create(base) {
        return QueryTraceCallRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseQueryTraceCallRequest();
        message.args = object.args ?? new Uint8Array();
        message.gasCap = object.gasCap ?? "0";
        message.proposerAddress = object.proposerAddress ?? new Uint8Array();
        message.traceConfig = (object.traceConfig !== undefined && object.traceConfig !== null)
            ? TraceConfig.fromPartial(object.traceConfig)
            : undefined;
        message.blockNumber = object.blockNumber ?? "0";
        message.blockHash = object.blockHash ?? "";
        message.blockTime = object.blockTime ?? undefined;
        message.chainId = object.chainId ?? "0";
        return message;
    },
};
function createBaseQueryTraceCallResponse() {
    return { data: new Uint8Array() };
}
export const QueryTraceCallResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.data.length !== 0) {
            writer.uint32(10).bytes(message.data);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryTraceCallResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { data: isSet(object.data) ? bytesFromBase64(object.data) : new Uint8Array() };
    },
    toJSON(message) {
        const obj = {};
        message.data !== undefined &&
            (obj.data = base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    create(base) {
        return QueryTraceCallResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseQueryTraceCallResponse();
        message.data = object.data ?? new Uint8Array();
        return message;
    },
};
function createBaseQueryTraceBlockRequest() {
    return {
        txs: [],
        traceConfig: undefined,
        blockNumber: "0",
        blockHash: "",
        blockTime: undefined,
        proposerAddress: new Uint8Array(),
        chainId: "0",
    };
}
export const QueryTraceBlockRequest = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.txs) {
            MsgEthereumTx.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.traceConfig !== undefined) {
            TraceConfig.encode(message.traceConfig, writer.uint32(26).fork()).ldelim();
        }
        if (message.blockNumber !== "0") {
            writer.uint32(40).int64(message.blockNumber);
        }
        if (message.blockHash !== "") {
            writer.uint32(50).string(message.blockHash);
        }
        if (message.blockTime !== undefined) {
            Timestamp.encode(toTimestamp(message.blockTime), writer.uint32(58).fork()).ldelim();
        }
        if (message.proposerAddress.length !== 0) {
            writer.uint32(66).bytes(message.proposerAddress);
        }
        if (message.chainId !== "0") {
            writer.uint32(72).int64(message.chainId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryTraceBlockRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.txs.push(MsgEthereumTx.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.traceConfig = TraceConfig.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.blockNumber = longToString(reader.int64());
                    break;
                case 6:
                    message.blockHash = reader.string();
                    break;
                case 7:
                    message.blockTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.proposerAddress = reader.bytes();
                    break;
                case 9:
                    message.chainId = longToString(reader.int64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            txs: Array.isArray(object?.txs) ? object.txs.map((e) => MsgEthereumTx.fromJSON(e)) : [],
            traceConfig: isSet(object.traceConfig) ? TraceConfig.fromJSON(object.traceConfig) : undefined,
            blockNumber: isSet(object.blockNumber) ? String(object.blockNumber) : "0",
            blockHash: isSet(object.blockHash) ? String(object.blockHash) : "",
            blockTime: isSet(object.blockTime) ? fromJsonTimestamp(object.blockTime) : undefined,
            proposerAddress: isSet(object.proposerAddress) ? bytesFromBase64(object.proposerAddress) : new Uint8Array(),
            chainId: isSet(object.chainId) ? String(object.chainId) : "0",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.txs) {
            obj.txs = message.txs.map((e) => e ? MsgEthereumTx.toJSON(e) : undefined);
        }
        else {
            obj.txs = [];
        }
        message.traceConfig !== undefined &&
            (obj.traceConfig = message.traceConfig ? TraceConfig.toJSON(message.traceConfig) : undefined);
        message.blockNumber !== undefined && (obj.blockNumber = message.blockNumber);
        message.blockHash !== undefined && (obj.blockHash = message.blockHash);
        message.blockTime !== undefined && (obj.blockTime = message.blockTime.toISOString());
        message.proposerAddress !== undefined &&
            (obj.proposerAddress = base64FromBytes(message.proposerAddress !== undefined ? message.proposerAddress : new Uint8Array()));
        message.chainId !== undefined && (obj.chainId = message.chainId);
        return obj;
    },
    create(base) {
        return QueryTraceBlockRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseQueryTraceBlockRequest();
        message.txs = object.txs?.map((e) => MsgEthereumTx.fromPartial(e)) || [];
        message.traceConfig = (object.traceConfig !== undefined && object.traceConfig !== null)
            ? TraceConfig.fromPartial(object.traceConfig)
            : undefined;
        message.blockNumber = object.blockNumber ?? "0";
        message.blockHash = object.blockHash ?? "";
        message.blockTime = object.blockTime ?? undefined;
        message.proposerAddress = object.proposerAddress ?? new Uint8Array();
        message.chainId = object.chainId ?? "0";
        return message;
    },
};
function createBaseQueryTraceBlockResponse() {
    return { data: new Uint8Array() };
}
export const QueryTraceBlockResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.data.length !== 0) {
            writer.uint32(10).bytes(message.data);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryTraceBlockResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { data: isSet(object.data) ? bytesFromBase64(object.data) : new Uint8Array() };
    },
    toJSON(message) {
        const obj = {};
        message.data !== undefined &&
            (obj.data = base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    create(base) {
        return QueryTraceBlockResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseQueryTraceBlockResponse();
        message.data = object.data ?? new Uint8Array();
        return message;
    },
};
function createBaseQueryBaseFeeRequest() {
    return {};
}
export const QueryBaseFeeRequest = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryBaseFeeRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return QueryBaseFeeRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseQueryBaseFeeRequest();
        return message;
    },
};
function createBaseQueryBaseFeeResponse() {
    return { baseFee: "" };
}
export const QueryBaseFeeResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.baseFee !== "") {
            writer.uint32(10).string(message.baseFee);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryBaseFeeResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.baseFee = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { baseFee: isSet(object.baseFee) ? String(object.baseFee) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.baseFee !== undefined && (obj.baseFee = message.baseFee);
        return obj;
    },
    create(base) {
        return QueryBaseFeeResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseQueryBaseFeeResponse();
        message.baseFee = object.baseFee ?? "";
        return message;
    },
};
export class QueryClientImpl {
    rpc;
    constructor(rpc) {
        this.rpc = rpc;
        this.Account = this.Account.bind(this);
        this.CosmosAccount = this.CosmosAccount.bind(this);
        this.ValidatorAccount = this.ValidatorAccount.bind(this);
        this.Balance = this.Balance.bind(this);
        this.Storage = this.Storage.bind(this);
        this.Code = this.Code.bind(this);
        this.Params = this.Params.bind(this);
        this.EthCall = this.EthCall.bind(this);
        this.EstimateGas = this.EstimateGas.bind(this);
        this.TraceTx = this.TraceTx.bind(this);
        this.TraceBlock = this.TraceBlock.bind(this);
        this.TraceCall = this.TraceCall.bind(this);
        this.BaseFee = this.BaseFee.bind(this);
    }
    Account(request, metadata) {
        return this.rpc.unary(QueryAccountDesc, QueryAccountRequest.fromPartial(request), metadata);
    }
    CosmosAccount(request, metadata) {
        return this.rpc.unary(QueryCosmosAccountDesc, QueryCosmosAccountRequest.fromPartial(request), metadata);
    }
    ValidatorAccount(request, metadata) {
        return this.rpc.unary(QueryValidatorAccountDesc, QueryValidatorAccountRequest.fromPartial(request), metadata);
    }
    Balance(request, metadata) {
        return this.rpc.unary(QueryBalanceDesc, QueryBalanceRequest.fromPartial(request), metadata);
    }
    Storage(request, metadata) {
        return this.rpc.unary(QueryStorageDesc, QueryStorageRequest.fromPartial(request), metadata);
    }
    Code(request, metadata) {
        return this.rpc.unary(QueryCodeDesc, QueryCodeRequest.fromPartial(request), metadata);
    }
    Params(request, metadata) {
        return this.rpc.unary(QueryParamsDesc, QueryParamsRequest.fromPartial(request), metadata);
    }
    EthCall(request, metadata) {
        return this.rpc.unary(QueryEthCallDesc, EthCallRequest.fromPartial(request), metadata);
    }
    EstimateGas(request, metadata) {
        return this.rpc.unary(QueryEstimateGasDesc, EthCallRequest.fromPartial(request), metadata);
    }
    TraceTx(request, metadata) {
        return this.rpc.unary(QueryTraceTxDesc, QueryTraceTxRequest.fromPartial(request), metadata);
    }
    TraceBlock(request, metadata) {
        return this.rpc.unary(QueryTraceBlockDesc, QueryTraceBlockRequest.fromPartial(request), metadata);
    }
    TraceCall(request, metadata) {
        return this.rpc.unary(QueryTraceCallDesc, QueryTraceCallRequest.fromPartial(request), metadata);
    }
    BaseFee(request, metadata) {
        return this.rpc.unary(QueryBaseFeeDesc, QueryBaseFeeRequest.fromPartial(request), metadata);
    }
}
export const QueryDesc = { serviceName: "injective.evm.v1.Query" };
export const QueryAccountDesc = {
    methodName: "Account",
    service: QueryDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return QueryAccountRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            const value = QueryAccountResponse.decode(data);
            return {
                ...value,
                toObject() {
                    return value;
                },
            };
        },
    },
};
export const QueryCosmosAccountDesc = {
    methodName: "CosmosAccount",
    service: QueryDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return QueryCosmosAccountRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            const value = QueryCosmosAccountResponse.decode(data);
            return {
                ...value,
                toObject() {
                    return value;
                },
            };
        },
    },
};
export const QueryValidatorAccountDesc = {
    methodName: "ValidatorAccount",
    service: QueryDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return QueryValidatorAccountRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            const value = QueryValidatorAccountResponse.decode(data);
            return {
                ...value,
                toObject() {
                    return value;
                },
            };
        },
    },
};
export const QueryBalanceDesc = {
    methodName: "Balance",
    service: QueryDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return QueryBalanceRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            const value = QueryBalanceResponse.decode(data);
            return {
                ...value,
                toObject() {
                    return value;
                },
            };
        },
    },
};
export const QueryStorageDesc = {
    methodName: "Storage",
    service: QueryDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return QueryStorageRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            const value = QueryStorageResponse.decode(data);
            return {
                ...value,
                toObject() {
                    return value;
                },
            };
        },
    },
};
export const QueryCodeDesc = {
    methodName: "Code",
    service: QueryDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return QueryCodeRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            const value = QueryCodeResponse.decode(data);
            return {
                ...value,
                toObject() {
                    return value;
                },
            };
        },
    },
};
export const QueryParamsDesc = {
    methodName: "Params",
    service: QueryDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return QueryParamsRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            const value = QueryParamsResponse.decode(data);
            return {
                ...value,
                toObject() {
                    return value;
                },
            };
        },
    },
};
export const QueryEthCallDesc = {
    methodName: "EthCall",
    service: QueryDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return EthCallRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            const value = MsgEthereumTxResponse.decode(data);
            return {
                ...value,
                toObject() {
                    return value;
                },
            };
        },
    },
};
export const QueryEstimateGasDesc = {
    methodName: "EstimateGas",
    service: QueryDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return EthCallRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            const value = EstimateGasResponse.decode(data);
            return {
                ...value,
                toObject() {
                    return value;
                },
            };
        },
    },
};
export const QueryTraceTxDesc = {
    methodName: "TraceTx",
    service: QueryDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return QueryTraceTxRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            const value = QueryTraceTxResponse.decode(data);
            return {
                ...value,
                toObject() {
                    return value;
                },
            };
        },
    },
};
export const QueryTraceBlockDesc = {
    methodName: "TraceBlock",
    service: QueryDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return QueryTraceBlockRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            const value = QueryTraceBlockResponse.decode(data);
            return {
                ...value,
                toObject() {
                    return value;
                },
            };
        },
    },
};
export const QueryTraceCallDesc = {
    methodName: "TraceCall",
    service: QueryDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return QueryTraceCallRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            const value = QueryTraceCallResponse.decode(data);
            return {
                ...value,
                toObject() {
                    return value;
                },
            };
        },
    },
};
export const QueryBaseFeeDesc = {
    methodName: "BaseFee",
    service: QueryDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return QueryBaseFeeRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            const value = QueryBaseFeeResponse.decode(data);
            return {
                ...value,
                toObject() {
                    return value;
                },
            };
        },
    },
};
export class GrpcWebImpl {
    host;
    options;
    constructor(host, options) {
        this.host = host;
        this.options = options;
    }
    unary(methodDesc, _request, metadata) {
        const request = { ..._request, ...methodDesc.requestType };
        const maybeCombinedMetadata = metadata && this.options.metadata
            ? new BrowserHeaders({ ...this.options?.metadata.headersMap, ...metadata?.headersMap })
            : metadata || this.options.metadata;
        return new Promise((resolve, reject) => {
            grpc.unary(methodDesc, {
                request,
                host: this.host,
                metadata: maybeCombinedMetadata,
                transport: this.options.transport,
                debug: this.options.debug,
                onEnd: function (response) {
                    if (response.status === grpc.Code.OK) {
                        resolve(response.message.toObject());
                    }
                    else {
                        const err = new GrpcWebError(response.statusMessage, response.status, response.trailers);
                        reject(err);
                    }
                },
            });
        });
    }
}
var tsProtoGlobalThis = (() => {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof global !== "undefined") {
        return global;
    }
    throw "Unable to locate global object";
})();
function bytesFromBase64(b64) {
    if (tsProtoGlobalThis.Buffer) {
        return Uint8Array.from(tsProtoGlobalThis.Buffer.from(b64, "base64"));
    }
    else {
        const bin = tsProtoGlobalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (tsProtoGlobalThis.Buffer) {
        return tsProtoGlobalThis.Buffer.from(arr).toString("base64");
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(String.fromCharCode(byte));
        });
        return tsProtoGlobalThis.btoa(bin.join(""));
    }
}
function toTimestamp(date) {
    const seconds = Math.trunc(date.getTime() / 1_000).toString();
    const nanos = (date.getTime() % 1_000) * 1_000_000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = Number(t.seconds) * 1_000;
    millis += t.nanos / 1_000_000;
    return new Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof Date) {
        return o;
    }
    else if (typeof o === "string") {
        return new Date(o);
    }
    else {
        return fromTimestamp(Timestamp.fromJSON(o));
    }
}
function longToString(long) {
    return long.toString();
}
if (_m0.util.Long !== Long) {
    _m0.util.Long = Long;
    _m0.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
export class GrpcWebError extends tsProtoGlobalThis.Error {
    code;
    metadata;
    constructor(message, code, metadata) {
        super(message);
        this.code = code;
        this.metadata = metadata;
    }
}
